module.exports = __webpack_public_path__ + "img/head2x.583f2026.png";